/* eslint-disable */
import {SwipeableDrawer, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import {
    ContentContainer,
    WidgetContainer, StyledWidgetButtonDrawer
} from "./WidgetDrawer.styles";
import {
    CardUserGoals,
    KeepLearningWidget,
    PreviewWidget
    // NewsCard
} from "../../components";
import {useAuthStore} from "../../stores";
import {useOutletContext} from "react-router-dom";
import {CardUserCampaigns} from "../CardUserCampaigns";
import {AgendaWidget} from "../../components/AgendaWidget";
import {UserProgressWidget} from "../../components/UserProgressWidget/UserProgressWidget";
import {CardRanking} from "../CardRanking/CardRanking.component";
import {CardGoals} from "../CardGoals/CardGoals.component";
import {ChevronRight, ChevronUp } from "lucide-react";
import {useTranslation} from "react-i18next";
import { ButtonDigited } from "../../components/Button/Button.variants";

export function WidgetDrawer() {
    const {showTutorialWidget}: any = useOutletContext();
    const [isOpened, setIsOpened] = React.useState(false);
    const theme = useTheme();
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const smartConfiguration = useAuthStore(state => state.smartConfiguration);

    const isLoading = useAuthStore(state => state.isLoading);
    const isAuthenticated = useAuthStore(state => Boolean(state.userData && state.userInfo));
    const isLoginComplete = !isLoading && isAuthenticated;

    const widgetsAreEnabled =
        smartConfiguration?.leaderboard === true
        || smartConfiguration?.widgetBadge === true
        || smartConfiguration?.widgetContinueLearning === true
        || smartConfiguration?.widgetCalendar === true
        || smartConfiguration?.widgetEditorial === true;

    React.useEffect(() => {
        setIsOpened(showTutorialWidget);
    }, [showTutorialWidget]);

    return widgetsAreEnabled ? (
        <>
            <StyledWidgetButtonDrawer
                onClick={() => {
                    setIsOpened(true);
                }}
                style={
                    !isOpened ? {
                        position: "fixed",
                        top: "20rem",
                        right: "1rem",
                        transform: "rotate(-90deg) translateX(100%)",
                        transformOrigin: "right center",
                        borderRadius: "0.25rem 0.25rem 0 0",
                    } : {
                        display: "none"
                    }}>
                <ChevronUp
                    size={"1rem"}
                    color={theme.customColors.textPrimaryCta}
                />
                <Typography fontSize="0.875rem" color={theme.customColors.textPrimaryCta}>
                    {t("tutorial-step-3-title")}
                </Typography>
            </StyledWidgetButtonDrawer>
            <SwipeableDrawer
                open={isOpened}
                anchor={"right"}
                hideBackdrop={false}
                disablePortal={true}
                onClose={() => {
                    setIsOpened(false);
                }}
                onOpen={() => {
                    setIsOpened(true);
                }}
                PaperProps={{
                    sx: {
                        background: "transparent",
                        boxShadow: "none",
                        height: "calc(100% - 6rem)",
                        width: "27rem",
                        overflowY: "visible",
                        top: isMobile ? "8.8rem" : " 5rem",
                        [theme.breakpoints.down("sm")]: {
                            maxWidth: "100%",
                            padding:"0.875rem",
                            top:"3rem"
                        },

                        ".MuiPaper-root": {
                            overflowX: "hidden",
                            overflowY: "auto",
                        }

                    }
                }}
                slotProps={{backdrop: {classes: {root: "backdrop-widget"}}}}
                sx={{position: "relative", zIndex: "1400"}}
            >
                {/*
                    //keyremount force the widgets to re-render so they
                        // trigger "fetching on mount" for the queries
                     */}
                <ContentContainer style={{position: "relative", marginTop: "2.5rem"}}>

                            <WidgetContainer>
                              <ButtonDigited
                                aria-label={t("close_widget_drawer")}
                                typology="primary"
                                onClick={() => {
                                  setIsOpened(false);
                                }}
                                sx={{
                                  justifyContent:"center",
                                  borderRadius: "0.5rem",
                                  position: "fixed",
                                  padding: "0.25rem 0.5rem",
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  marginTop: "-3.875rem"
                                }}
                              >
                                <ChevronRight
                                  size={"1rem"}
                                  color={theme.customColors.textPrimaryCta }
                                />
                              </ButtonDigited>
                                { smartConfiguration?.widgetEditorial && <PreviewWidget enabled={ isOpened && isLoginComplete }/> }
                                {smartConfiguration?.widgetCalendar && <AgendaWidget enabled={ isOpened && isLoginComplete}/>}
                                <UserProgressWidget enabled={ isOpened && isLoginComplete}/>
                                {smartConfiguration?.widgetContinueLearning && <KeepLearningWidget enabled={ isOpened && isLoginComplete} setIsOpened={setIsOpened}/>}
                                <CardRanking isUserPage={false} enabled={ isOpened && isLoginComplete }/>
                                { /*{ smartConfiguration?.widgetLeaderboard && <CardRanking isUserPage={ false } /> }*/}
                                {smartConfiguration?.widgetBadge && <CardGoals enabled={ isOpened && isLoginComplete}/>}
                                { /* <NewsCard { ...NewsCardVariants.Default }/> */}
                                <CardUserGoals color={theme.customColors.textWidget} isProfilePage={false} enabled={ isOpened && isLoginComplete }/>
                                <CardUserCampaigns enabled={ isOpened && isLoginComplete}/>
                            </WidgetContainer>
                </ContentContainer>
            </SwipeableDrawer>
        </>
    ) : null;
}
